import React from "react";
import { useLocation } from "react-router-dom";
import CRMGlobalSearch from "./CRMGlobalSearch";

const routeTitleMap = {
  "/crm": "CRM Overview",
  "/crm/dashboard": "CRM Dashboard",
  "/crm/forecast": "CRM Forecast",
  "/crm/leads": "Lead Management",
  "/crm/accounts": "Accounts",
  "/crm/contacts": "Contacts",
  "/crm/opportunities": "Opportunity Pipeline",
  "/crm/quotes": "Quotes",
  "/crm/collections": "Collections",
  "/crm/settings": "CRM Settings",
};

const CRMTopbar = () => {
  const location = useLocation();
  const title = routeTitleMap[location.pathname] || "CRM Workspace";

  return (
    <header className="crm-topbar">
      <div className="crm-topbar-content">
        <div>
          <h1 className="crm-topbar-title">{title}</h1>
          <p className="crm-topbar-subtitle">
            Manage prospects, customers, quotes, receivables, and forecasting in
            one place.
          </p>
        </div>

        <CRMGlobalSearch />
      </div>
    </header>
  );
};

export default CRMTopbar;
